'use strict';

function CompanyUserService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/users/:userId', {}, {
    'update': { method:'PUT' },
    'queryUsersInvited': {
      url: config.apiBase + '/companies/:companyId/users/invited',
      method: 'GET',
      isArray: true
    },
    'queryInactive': {
      url: config.apiBase + '/companies/:companyId/users?active=false&all=true&limit=1000',
      method: 'GET',
      isArray: true
    },
    'removeInvited': {
      url: config.apiBase + '/companies/:companyId/users/delete-invited',
      method: 'DELETE'
    },
    'queryUserTags': {
      url: config.apiBase + '/companies/:companyId/users/:userId/tags',
      method: 'GET',
      isArray: true
    },
    'createUserTag': {
      url: config.apiBase + '/companies/:companyId/users/:userId/tags',
      method: 'POST'
    },
    'deleteUserTag': {
      url: config.apiBase + '/companies/:companyId/users/:userId/tags/:tagId',
      method: 'DELETE',
      isArray: true
    },
    'updateMassEdit': {
      url: config.apiBase + '/companies/:companyId/users/massedit',
      method: 'POST'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyUserService', ['$resource', 'config', CompanyUserService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/users/CompanyUserService.js
// module id = 11
// module chunks = 0